export default {"src":"/_next/static/media/man-thumbs-up.colour.769e0c86.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};